import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { SUBMIT_PAYMENTS_RECEIPT_EMAIL_REQUEST } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  SubmitReceiptEmailRequestPayload,
  SubmitReceiptEmailResult,
} from '../types/submitReceiptEmailRequest.types';

export const submitReceiptEmailRequest = (builder: BuilderType) =>
  builder.mutation<SubmitReceiptEmailResult, SubmitReceiptEmailRequestPayload>({
    query: (params) => ({
      data: params,
      method: 'POST',
      url: SUBMIT_PAYMENTS_RECEIPT_EMAIL_REQUEST,
    }),
    transformResponse(response: GenericApiResponse<SubmitReceiptEmailResult>) {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
